import { create } from "zustand";

interface DailyAttendanceModalState {
	detailModalOpen: boolean;
	selectedId: string | null;
}

interface DailyAttendanceModalActions {
	openDetailModal: (id: string) => void;
	closeDetailModal: () => void;
}

type DailyAttendanceModalStore = DailyAttendanceModalState & DailyAttendanceModalActions;

export const useDailyAttendanceModalStore = create<DailyAttendanceModalStore>((set) => ({
	detailModalOpen: false,
	selectedId: null,

	openDetailModal: (id) => set({ detailModalOpen: true, selectedId: id }),
	closeDetailModal: () => set({ detailModalOpen: false, selectedId: null }),
}));
